import { toast } from 'sonner';
import { API_ENDPOINTS, HTTP_METHODS } from '../config/api';
import { BaseApiService, ApiResponse } from './baseApi';

// Kept intentionally flexible to tolerate backend field naming differences.
export interface CreditDebitReportRow {
  noteNo?: string;
  noteDate?: string;
  /** When present, opens note view directly */
  creditDebitNoteId?: number;
  salesInvoiceNo?: string;
  salesInvoiceDate?: string;
  /** When present, opens invoice view directly */
  referenceInvoiceId?: number;
  invoiceHeaderId?: number;
  salesInvoiceId?: number;
  voucherType?: string;
  partyName?: string;
  customerAddress?: string;
  gstin?: string;
  pan?: string;
  itemName?: string;
  hsnCode?: string;
  billedQuantity?: number;
  rate?: number;
  unit?: string;
  amount?: number;
  cgstRate?: number;
  cgstAmount?: number;
  sgstRate?: number;
  sgstAmount?: number;
  igstRate?: number;
  igstAmount?: number;
  tcsRate?: number | null;
  tcsAmount?: number;
  totalTaxAmount?: number;
  otherCharges?: number;
  additionalRemarks?: string;
}

class CreditDebitReportApiService extends BaseApiService {
  async getCreditDebitReport(
    branchId?: number,
    startDate?: string,
    endDate?: string
  ): Promise<ApiResponse<CreditDebitReportRow[]>> {
    try {
      const response = await this.makeRequest<ApiResponse<CreditDebitReportRow[]> | CreditDebitReportRow[]>(
        API_ENDPOINTS.INVOICE_REPORTS.CREDIT_DEBIT(branchId, startDate, endDate),
        { method: HTTP_METHODS.GET }
      );

      if (Array.isArray(response)) {
        return {
          success: true,
          message: 'Credit/debit report fetched successfully',
          data: response,
        };
      }

      return {
        success: Boolean(response?.success),
        message: response?.message || 'Credit/debit report fetched successfully',
        data: Array.isArray(response?.data) ? response.data : [],
        timestamp: response?.timestamp,
        pagination: response?.pagination,
      };
    } catch (error) {
      toast.error('Failed to fetch credit/debit report');
      throw error;
    }
  }
}

export const creditDebitReportApiService = new CreditDebitReportApiService();

